import { read } from '@/api/rest';

const udcUser = {
  index: async () => await read('/udc-user'),
};
export default udcUser;
